export default {
  path: '/bmr',
  component: (resolve) => require(['@/views/bmr/index.vue'], resolve),
  redirect: '/bmr/asset/baremetal-list',
  children: [
    {
      path: '/bmr/asset/baremetal-list',
      component: (resolve) => require(['@/views/bmr/asset/baremetal/index.vue'], resolve)
    },
    {
      path: '/bmr/asset/baremetal/:baremetalId',
      component: (resolve) => require(['@/views/bmr/asset/baremetal/BaremetalDetails.vue'], resolve)
    },
    {
      path: '/bmr/asset/current',
      component: (resolve) => require(['@/views/bmr/asset/current/index.vue'], resolve)
    },
    {
      path: '/bmr/asset/purchase/purchase-list',
      component: (resolve) => require(['@/views/bmr/asset/purchase/PurchaseList.vue'], resolve)
    },
    {
      path: '/bmr/asset/purchase/:purchaseId',
      redirect: '/bmr/asset/purchase/:purchaseId/particulars',
      component: (resolve) => require(['@/views/bmr/asset/purchase/profile/index.vue'], resolve),
      children: [
        {
          path: '/bmr/asset/purchase/:purchaseId/particulars',
          component: (resolve) =>
            require(['@/views/bmr/asset/purchase/profile/particulars/index.vue'], resolve)
        },
        {
          path: '/bmr/asset/purchase/:purchaseId/inventories',
          component: (resolve) =>
            require(['@/views/bmr/asset/purchase/profile/Inventories.vue'], resolve)
        },
        {
          path: '/bmr/asset/purchase/:purchaseId/activities',
          component: (resolve) =>
            require(['@/views/bmr/asset/purchase/profile/Activities.vue'], resolve)
        }
      ]
    },
    {
      path: '/bmr/asset/inventory/inventory-list',
      component: (resolve) => require(['@/views/bmr/asset/inventory/index.vue'], resolve)
    }
  ]
};
